import {Box, Divider, Grid, Step, StepLabel, Stepper} from '@material-ui/core';
import {DescriptionOutlined} from '@material-ui/icons';
import React, {Component, Fragment} from 'react';
import {autobind} from 'core-decorators';
import Button from 'components/button';
import {Field, FileInput, Form, Input, Select} from 'components/forms';
import {refundForm} from 'components/forms/decorators';
import {gt} from 'components/forms/form/validators';
import SectionBanner from 'components/section-banner';
import createRouteSignsDealerOrderMutation from 'graphql/mutations/orders/create-route-sign-dealer-refund-order.gql';
import RouteSingsPopup from 'components/route-signs-popup';
import styles from './styles.css';

@refundForm(createRouteSignsDealerOrderMutation)
@autobind
export default class RouteSignsCreate extends Component {
    state = {
        activeStep: 0,
    };

    getSteps() {
        return ['Datos del pedido', 'Ubicación del cartel', 'Resumen del pedido'];
    }

    validateStep(step, values) {
        const errors = {};
        switch (step) {
            case 0:
                if (!values.estimatedAmount) errors.estimatedAmount = 'Este campo es obligatorio';
                if (!values.singBudget || values.singBudget.length === 0) errors.singBudget = 'Este campo es obligatorio';
                if (!values.singLogo || values.singLogo.length === 0) errors.singLogo = 'Este campo es obligatorio';
                if (!values.singAddress) errors.singAddress = 'Este campo es obligatorio';
                if (!values.supplier) errors.supplier = 'Este campo es obligatorio';
                if (values.supplier === 'otro' && !values.deteailedSupplier) errors.deteailedSupplier = 'Este campo es obligatorio';
                break;
            case 1:
                if (!values.signRoute) errors.signRoute = 'Este campo es obligatorio';
                if (!values.signKm) errors.signKm = 'Este campo es obligatorio';
                break;
            default:
                break;
        }
        return errors;
    }

    renderRouteSingsPopup() {
        return <RouteSingsPopup />;
    }

    render() {
        const options = [
            {label: 'STRAFFELA', value: 'STRAFFELA'},
            {label: 'MEDIA STRATEGY', value: 'MEDIA STRATEGY'},
            {label: 'PUBLICAR SA', value: 'PUBLICAR SA'},
            {label: 'Otro', value: 'otro'},
        ];
        const steps = this.getSteps();
        const handleNext = (values) => {
            const errors = this.validateStep(this.state.activeStep, values);
            if (Object.keys(errors).length === 0) {
                this.setState(prevState => ({activeStep: prevState.activeStep + 1, errors: {}}));
            } else {
                this.setState({errors});
            }
        };
        const handleBack = () => {
            this.setState(prevState => ({activeStep: prevState.activeStep - 1, errors: {}}));
        };
        return (
            <div className={styles.root}>
                <SectionBanner />
                <Stepper activeStep={this.state.activeStep} style={{px: 0}} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Form
                    fields={[
                        {key: 'estimatedAmount', validators: [gt(0)]},
                        {key: 'singBudget'},
                        {key: 'singLogo'},
                        {key: 'singAddress'},
                        {key: 'supplier'},
                        {key: 'deteailedSupplier', required: false},
                        {key: 'signRoute'},
                        {key: 'signKm'},
                        {key: 'signWay', required: false},
                    ]}
                    errors={this.props.errors || this.state.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid, values}) => {
                        return (
                            <Fragment>
                                {this.state.activeStep === 0 &&
                                <Fragment>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <p className={styles.title}>Datos del pedido</p>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Presupuesto(*)'>
                                                <Input
                                                    type='number'
                                                    placeholder='Ingresá un monto'
                                                    {...getFieldProps('estimatedAmount')}
                                                />
                                                {renderErrors('estimatedAmount')}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Adjuntar presupuesto(*)'>
                                                <FileInput {...getFieldProps('singBudget')} />
                                                {renderErrors('singBudget')}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Adjuntá tu logo(*)'>
                                                <FileInput {...getFieldProps('singLogo')} />
                                                {renderErrors('singLogo')}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Dirección que figurará en el cartel(*)'>
                                                <Input
                                                    placeholder='Ingresá una dirección'
                                                    {...getFieldProps('singAddress')}
                                                />
                                                {renderErrors('singAddress')}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Proveedor elegido(*)'>
                                                <Select
                                                    clearable
                                                    options={options}
                                                    placeholder='Nombre del proveedor'
                                                    {...getFieldProps('supplier')}
                                                />
                                                {renderErrors('supplier')}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            {values.supplier === 'otro' && (
                                                <Field label='Nombre del proveedor(*)'>
                                                    <Input
                                                        placeholder='Nombre del proveedor'
                                                        {...getFieldProps('deteailedSupplier')}
                                                    />
                                                    {renderErrors('deteailedSupplier')}
                                                </Field>
                                            )}
                                        </Grid>
                                        <Grid item container justify='flex-end' xs={12}>
                                            <Grid item xs={4}>
                                                <Button type='button' fullWidth theme='yellow' onClick={() => handleNext(values)}>
                                                    continuar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>}
                                {this.state.activeStep === 1 &&
                                <Fragment>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <p className={styles.title}>Ubicación del cartel</p>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Ruta / Camino(*)'>
                                                <Input
                                                    placeholder='Ingresá la ruta o el camino'
                                                    {...getFieldProps('signRoute')}
                                                />
                                                {renderErrors('signRoute')}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Km / Cruce(*)'>
                                                <Input
                                                    placeholder='Ingresá el Km o el cruce'
                                                    {...getFieldProps('signKm')}
                                                />
                                                {renderErrors('signKm')}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Field label='Sentido (opcional)'>
                                                <Input
                                                    placeholder='Ingresá el sentido de la calle'
                                                    {...getFieldProps('signWay')}
                                                />
                                                {renderErrors('signWay')}
                                            </Field>
                                        </Grid>
                                        <Grid item container xs={12} justify='space-between' alignItems='center'>
                                            <Grid item>
                                                <button type='button' style={{fontWeight: 600}} onClick={handleBack}>
                                                    Volver
                                                </button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button type='button' fullWidth theme='yellow' onClick={() => handleNext(values)}>
                                                    Continuar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>}
                                {this.state.activeStep === 2 &&
                                <Fragment>
                                    <Box className={styles.box}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <p className={styles.title}>Resumen del pedido</p>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p className={styles.valueLabel}>Presupuesto</p>
                                                <label>{values.estimatedAmount}</label>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p className={styles.valueLabel}>Presupuesto adjunto</p>
                                                {values.singBudget[0] && (
                                                    <div className={styles.fileLabel}>
                                                        <DescriptionOutlined />
                                                        <label className={styles.fileName}>{values.singBudget[0].name}</label>
                                                    </div>
                                                )}
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p className={styles.valueLabel}>Dirección que figurará en el cartel</p>
                                                <label>{values.singAddress}</label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                            <Grid item xs={4} alignItems='center' alignContent='center'>
                                                <p className={styles.valueLabel}>Logo adjunto</p>
                                                {values.singLogo[0] && (
                                                    <div className={styles.fileLabel}>
                                                        <DescriptionOutlined />
                                                        <label className={styles.fileName}>{values.singLogo[0].name}</label>
                                                    </div>
                                                )}
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p className={styles.valueLabel}>Proveedor elegido</p>
                                                <label>{values.supplier === 'Otro' ? values.deteailedSupplier : values.supplier}</label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <p className={styles.subtitle}>Ubicación del cartel</p>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p className={styles.valueLabel}>Ruta / Camino</p>
                                                <label>{values.signRoute}</label>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p className={styles.valueLabel}>Sentido</p>
                                                <label>{values.signWay}</label>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p className={styles.valueLabel}>Km / Cruce</p>
                                                <label>{values.signKm}</label>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Grid item container xs={12} justify='space-between' alignItems='center'>
                                        <Grid item>
                                            <button type='button' style={{fontWeight: 600}} onClick={handleBack}>
                                                Volver
                                            </button>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Form.Actions>
                                                <Button fullWidth theme='yellow' disabled={!isValid() || this.props.loading}>
                                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                                </Button>
                                            </Form.Actions>
                                            {renderErrors('__all__')}
                                        </Grid>
                                    </Grid>
                                </Fragment>}
                            </Fragment>
                        );
                    }}
                </Form>
                {this.renderRouteSingsPopup()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/route-signs/dealer/index.js